import { createSelector } from '@reduxjs/toolkit';
import { groupBy } from 'es-toolkit';
import type { RootState } from '../../configureStore';

export const analyticsSelector = ({ entities }: RootState) => {
  return entities.anaylytic;
};

export const getLoadingState = createSelector(
  analyticsSelector,
  ({ isFetching, isChangingAnalytic }) => {
    return {
      isFetching, isChangingAnalytic,
    };
  },
);

export const getSelectedDashboardId = createSelector(
  analyticsSelector,
  ({ selectedDashboardId }) => {
    return selectedDashboardId || '';
  },
);

export const getGroupedDashboardByType = createSelector(
  analyticsSelector,
  ({ dashboards }) => {
    return groupBy(dashboards, item => item.type);
  },
);

export const getGroupedDashboardById = createSelector(
  analyticsSelector,
  ({ dashboards }) => {
    return groupBy(dashboards, item => item.dashboardid!);
  },
);

export const getDashboardAnalytics = createSelector(
  [getGroupedDashboardById, getSelectedDashboardId],
  (groupedDashboardById, selectedDashboardId) => {
    return groupedDashboardById[selectedDashboardId]?.[0]?.analytics || [];
  },
);

export const getAnalyticResult = createSelector(
  [analyticsSelector, (_state, analyticid) => analyticid],
  ({ analyticResults }, analyticid) => analyticResults[analyticid] ?? {},
);

export const getAnalyticRunState = createSelector(
  [analyticsSelector, (_state, analyticid) => analyticid],
  ({ analyticRunState }, analyticid) => {
    return analyticRunState[analyticid];
  },
);

export const getNumberOfVisibleResults = createSelector(
  [analyticsSelector, (_state, analyticids) => analyticids],
  ({ analyticResults }, analyticids) => {
    return Object.keys(analyticResults).filter(key => analyticids.includes(key)).length;
  },
);

export const getFilters = createSelector(
  [analyticsSelector, (_state, analyticid) => analyticid],
  ({ filters }, analyticid) => {
    return filters[analyticid] ?? {};
  },
);